import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const ViewMore = dynamic(() => import('../../../components/ViewMore'));

const WeValueTIme = props => {
  return (
    <>
      <Head>
        <title>We Value Your Time - WeProdigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/about-us/we-value-time" />
        <meta
          name="description"
          content="Prodigi values your time as a priceless asset, investing it wisely in relationships, efficiency, and quality service to create real value."
        />
      </Head>
      <main>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/Group3198.png');
            background-position: center;
          }
          .bg-image-light {
            background-size: cover;
            background-image: url('/images/about/Group3198.png');
            background-position: center;
          }
          @media screen and (max-width: 758px) {
            .bg-image {
              background-image: url('/images/about/Group3206.png');
            }
            .bg-image-light {
              background-image: url('/images/about/Group3206.png');
            }
          }
        `}</style>
        <div className="relative w-full  h-700  overflow-hidden  bg-image">
          <div className="container h-full">
            <h1 className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <div className="uppercase text-white text-30 md:text-72 font-black leading-none">We Value</div>
              <div className="uppercase text-green text-30 md:text-72 font-black ">Time</div>
            </h1>
          </div>
        </div>
        <div className="body-part">
          <div className="bg-white">
            <div className="container py-30">
              The key is in not spending time but in investing in it! For us, time is the most valuable resource that we invest wisely in the
              relationship and community growth, valuing every day, every minute as a priceless asset for our partners, team members, and the company.
              Lastly, we should accept and be guided by the universal truth that, although bent and stretched, time is the only non-renewable
              resource.
            </div>
          </div>

          <div className="bg-gray-light">
            <div className="container py-30">
              <div className="titple text-purple text-24 leading-none  font-black uppercase">We value our partners’ time</div>
              <div className="flex flex-wrap justify-between mt-20">
                <div className="w-full md:w-half-auto">
                  <p>
                    {' '}
                    Modern business workflow is too quick to have the luxury of time on slow processes. Highly-competitive market, constantly rising
                    demand of consumers, the speed of technology development force companies and service providers to keep pace; otherwise, anyone out
                    of the tempo is out of the competition. What we do is evaluate both our time, the time of our partners and focus resources on
                    delivering better quality. We do realize the importance of accelerating processes not only on the C-suite level but also on the
                    management side; that is why time is the core value in the partnership.{' '}
                  </p>
                  <p>
                    Being exclusively client-oriented and working on creating value, our team has optimized channels to bridge the communication gap
                    through quality customer service. We are close to our partners being available 24/7 using different platforms chosen by clients;
                    Slack, Zoom, WhatsApp, Messenger, or any other channel.{' '}
                  </p>
                  <p>
                    By continuously improving all business processes, we still recognize customer service as the most crucial workforce component. To
                    be always available for clients, assist and address their needs saving their time on communication and problem solving; this is
                    how we generate satisfaction and build trust. Our account management team is carefully selected and regularly accredited to
                    provide the best possible support and gain customer satisfaction. The client-oriented solutions are created in all areas of
                    cooperation, from project approval to reporting.
                  </p>
                  <p className="font-bold">Your time is our priority; saving your time, we save your resources and create value.</p>
                </div>
                <div className="w-full md:w-half-auto">
                  <picture className="">
                    <source srcSet="/images/about/Groups3199.png" type="image/png" />
                    <img src="/images/about/Groups3199.png" alt="discover image" width="540" height="515" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-image-light w-full min-h-171">
            <div className="container max-w-800 flex  h-171 flex-col justify-center items-center text-white font-500 text-18 md:text-24 text-center">
              <div className=""> “The key is in not spending time, but in investing it”</div>
              <div className="text-16 self-end">- Stephen R. Covey</div>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <div className="titple text-purple text-24 leading-none  font-black uppercase">We value our employees time</div>
              <p className="mt-20 hidden md:block">
                No success is possible without a dedicated team where each member is valued as a specialist and human. We value the time of our
                employees; that is why the first skill they acquire as a team member is time management, the skill to effectively use work hours to
                fulfill the tasks, meet deadlines and even have spare time for self-development. We leverage collective genius, value each minute
                spent with us, and foster the same time value in employees. To meet the standards of corporate values and never lose the atmosphere of
                friendliness, we have implemented a productivity tracking practice with Time Doctor software that allows each employee to adjust
                his/her own tasks, set task priorities, track the time spent for each task. We keep monitoring employee interaction to understand the
                bottlenecks and tackle them with new skill acquisition.
              </p>
              <p className="mt-20 block md:hidden">
                <ViewMore ln={80}>
                  No success is possible without a dedicated team where each member is valued as a specialist and human. We value the time of our
                  employees; that is why the first skill they acquire as a team member is time management, the skill to effectively use work hours to
                  fulfill the tasks, meet deadlines and even have spare time for self-development. We leverage collective genius, value each minute
                  spent with us, and foster the same time value in employees. To meet the standards of corporate values and never lose the atmosphere
                  of friendliness, we have implemented a productivity tracking practice with Time Doctor software that allows each employee to adjust
                  his/her own tasks, set task priorities, track the time spent for each task. We keep monitoring employee interaction to understand
                  the bottlenecks and tackle them with new skill acquisition.
                </ViewMore>
              </p>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <div className="flex flex-wrap justify-between mt-0 md:mt-20">
                <div className="w-full md:w-half-auto">
                  <picture className="hidden md:block">
                    <source srcSet="/images/about/sales_group_images1.png" type="image/png" />
                    <img src="/images/about/sales_group_images1.png" alt="discover image" width="540" height="515" />
                  </picture>
                </div>
                <div className="w-full md:w-half-auto">
                  <div className="titple text-purple text-24 leading-none font-black uppercase">We value our time</div>
                  <p className="mt-20">
                    The third component of time evaluation is our time, the way we treat the business and organize the processes. Keeping up the pace
                    of the digital world, we take ProDigi and the team along the path of constant development of services, skills, and knowledge,
                    spending each minute setting and achieving goals. That is why we can now speak aloud about our success and share our customers'
                    success stories heads up.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default WeValueTIme;
